import React from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import { Tag } from './ui/Tag';
import { savingRows, solutionChecks } from '../data/landing';
export function SolutionSection() {
  return <section className="w-full bg-[#f8fafc] py-20 sm:py-28" aria-labelledby="solucion-title" data-id="element-123" data-mp="3o90p39as4cn4">
      <div className="mx-auto grid w-full max-w-6xl gap-14 px-6 lg:grid-cols-2 lg:items-start lg:gap-16" data-id="element-124" data-mp="3jah358w6r0ur">
        <div data-id="element-125" data-mp="142rjgle32zj">
          <Tag data-id="element-126" data-mp="13t3vznth7x0">La Solución</Tag>
          <h2 id="solucion-title" className="mt-6 font-serif text-3xl font-bold leading-tight text-[#0f172a] sm:text-4xl lg:text-5xl" data-id="element-127" data-mp="12rpbl7le3aj">
            El Sistema que Cambia la Ecuación
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600" data-id="element-128" data-mp="atw0e9u5d403">
            No es una dieta. No es un recetario. Es el sistema operativo de tu
            alimentación: compra, preparación, nutrición deportiva, metabolismo y
            escala financiera funcionando como uno solo.
          </p>

          <ul className="mt-9 space-y-4" data-id="element-129" data-mp="fvbns8jsrmln">
            {solutionChecks.map(check => <li key={check} className="flex items-start gap-3" data-id="element-130" data-mp="36bno4gfcguxt">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#16a34a]" aria-hidden="true" data-id="element-131" data-mp="3b9fe34wfi6zd">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} data-id="element-132" data-mp="3faiw9y1y8f3r" />
                </span>
                <span className="text-sm leading-relaxed text-slate-700" data-id="element-133" data-mp="3kb6im6f8g7rn">
                  {check}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="rounded border border-[#24324f] bg-[#0f172a] p-8 sm:p-10" data-id="element-134" data-mp="3u81f6jry3y3a">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400" data-id="element-135" data-mp="2u5hgcbb5tyz">
            Ahorro Mensual con el Sistema Activo
          </p>
          <p className="mt-5 font-serif text-6xl font-bold text-[#22c55e] sm:text-7xl" data-id="element-136" data-mp="6uz1uvpjkqn4">
            $379k
          </p>
          <p className="mt-2 text-sm text-slate-400" data-id="element-137" data-mp="bsqw3wdnsouh">ARS recuperados cada mes</p>

          <ul className="mt-9 divide-y divide-white/10 border-t border-white/10" data-id="element-138" data-mp="gty5fzvg9w39">
            {savingRows.map(row => <li key={row.label} className="flex items-center justify-between gap-4 py-4" data-id="element-139" data-mp="2cuqfb3gps40r">
                <span className="flex items-center gap-3 text-sm text-slate-300" data-id="element-140" data-mp="27zjfw7uh9lhn">
                  <PlusIcon className="h-4 w-4 shrink-0 text-[#16a34a]" aria-hidden="true" data-id="element-141" data-mp="2mne7tm0nvlto" />
                  {row.label}
                </span>
                <span className="shrink-0 text-sm font-semibold text-white" data-id="element-142" data-mp="2vnarf9871uhv">
                  {row.amount}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}